import request from '@/utils/request'

export default {
  /** 批量添加role-permission  */
  insertPermissionBatch(data) {
    return request({
      method: 'POST',
      url: '/admin/commonRolePermission/addRolePermissionBatch',
      data
    })
  },
  /** 批量删除role-permission */
  deletePermissionBatch(data) {
    return request({
      method: 'POST',
      url: '/admin/commonRolePermission/deleteRolePermissionBatch',
      data
    })
  }
}
